import Reveal from '@/pages/zz-review/components/Reveal';

const specs = [
  { label: '書名', value: '《1001旋轉門 Revolving Gate》' },
  { label: '副書名', value: '智人如何入世成功揚升 5D' },
  { label: '英文書名', value: '1001 Revolving Gate' },
  { label: '作者', value: 'ABAA Wu' },
  { label: '出版者', value: '達太聯王股份有限公司' },
  { label: '全書', value: '十章、360 頁' },
  { label: '規格', value: '繁體中文、6 × 9 吋平裝' },
  { label: '定價', value: 'NT$468' },
  { label: 'ISBN', value: '978-626-473-012-9（平裝）' },
  { label: 'CIP', value: '115012098' },
  { label: '國圖主題詞', value: '成功法；靈修' },
  { label: '分類號', value: '177.2' },
];

export default function SpecsSection() {
  return (
    <section id="specs" className="w-full py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-10">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              書籍基本資料
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              一本 360 頁的繁體中文實踐書
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3">
              書籍規格與出版資訊，供嘖嘖專案部與贊助者參考。
            </p>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
            {specs.map((s, i) => (
              <div
                key={s.label}
                className={`grid grid-cols-1 sm:grid-cols-[180px_1fr] gap-2 sm:gap-6 px-6 md:px-8 py-5 md:py-6 ${
                  i !== 0 ? 'border-t border-background-200/70' : ''
                }`}
              >
                <div className="flex items-center">
                  <span className="text-xs md:text-sm font-medium text-foreground-400 whitespace-nowrap">
                    {s.label}
                  </span>
                </div>
                <div className="flex items-center">
                  <span className="text-sm md:text-base text-foreground-800 leading-relaxed">
                    {s.value}
                  </span>
                </div>
              </div>
            ))}

            <div className="grid grid-cols-1 sm:grid-cols-[180px_1fr] gap-2 sm:gap-6 px-6 md:px-8 py-5 md:py-6 border-t border-background-200/70 bg-primary-50">
              <div className="flex items-center">
                <span className="text-xs md:text-sm font-medium text-primary-800 whitespace-nowrap">
                  預計履約時程
                </span>
              </div>
              <div className="flex items-center">
                <span className="text-sm md:text-base text-foreground-900 font-medium leading-relaxed">
                  預計 2026 年 11 月中旬前完成臺灣批次寄送；海外件視物流工作天順延。
                </span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}